import { ReactComponent as NavLogo } from "../assets/carTheme/logo.svg";
import { ReactComponent as GradientScanFillIcon } from "../assets/carTheme/gradient-scan-icon.svg";
import { ReactComponent as WhiteScanFillIcon } from "../assets/carTheme/white-scan-icon.svg";
import { ReactComponent as GradientTabUploadIcon } from "../assets/carTheme/gradient-upload-icon.svg";
import { ReactComponent as WhiteTabUploadIcon } from "../assets/carTheme/white-upload-icon.svg";
import { ReactComponent as QrCodeIcon } from "../assets/carTheme/qr-code-icon.svg";
import { ReactComponent as CameraDeniedIcon } from "../assets/carTheme/camera-access-denied-icon.svg";
import { ReactComponent as DocumentFileIcon } from "../assets/carTheme/document.svg";
import { ReactComponent as VerificationSuccess } from "../assets/carTheme/verification-success-icon.svg";
import { ReactComponent as VerificationFailed } from "../assets/carTheme/verification-failed-icon.svg";
import { ReactComponent as GlobeSvgIcon } from "../assets/carTheme/globe.svg";
import { ReactComponent as ArrowDownSvgIcon } from "../assets/carTheme/arrow-down.svg";
import { ReactComponent as ArrowUpSvgIcon } from "../assets/carTheme/arrow-up.svg";
import { ReactComponent as CheckSvgIcon } from "../assets/carTheme/check.svg";
import { ReactComponent as InjiVerLogo } from "../assets/carTheme/inji-verify.svg";
import { ReactComponent as UnderConstructionLogo } from "../assets/carTheme/under-construction.svg";
import { ReactComponent as Search } from "../assets/carTheme/search.svg";
import { ReactComponent as FilterLines } from "../assets/carTheme/filter-lines.svg";
import { ReactComponent as Download } from "../assets/carTheme/download.svg";
import { ReactComponent as WhiteDownload } from "../assets/carTheme/white-download.svg";
import { ReactComponent as ReGenerate } from "../assets/carTheme/re-generate.svg";
import { ReactComponent as WhiteReGenerate } from "../assets/carTheme/white-regenerate.svg";
import { ReactComponent as CrossIcon } from "../assets/carTheme/close_icon.svg";
import { ReactComponent as HamburgerIcon } from "../assets/carTheme/hamburger-menu.svg";
import { ReactComponent as TabIcon } from "../assets/carTheme/new-tab.svg";
import { ReactComponent as VectorDownArrow } from "../assets/carTheme/vector-arrow-down.svg";
import { ReactComponent as VectorUpArrow } from "../assets/carTheme/vector-arrow-up.svg";
import { ReactComponent as VectorExpandIcon } from "../assets/carTheme/vector-expand.svg";
import { ReactComponent as VectorCollapseIcon } from "../assets/carTheme/vector-collapse.svg";
import { ReactComponent as VectorDownloadIcon } from "../assets/carTheme/vector-download.svg";
import { ReactComponent as SharableLinkIcon } from "../assets/carTheme/sharable-link.svg";
import ScannerOutline from "../assets/carTheme/scanner-outline.svg";
import QrOutline from "../assets/carTheme/qr-code-outline.svg";
import VectorOutline from "../assets/carTheme/vector-icon-outline.svg";

const carTheme = {
  Logo: NavLogo,
  InjiLogo: InjiVerLogo,
  QrIcon: QrCodeIcon,
  GradientScanIcon: GradientScanFillIcon,
  WhiteScanIcon: WhiteScanFillIcon,
  GradientUploadIcon: GradientTabUploadIcon,
  WhiteUploadIcon: WhiteTabUploadIcon,
  CameraAccessDeniedIcon: CameraDeniedIcon,
  DocumentIcon: DocumentFileIcon,
  VerificationSuccessIcon: VerificationSuccess,
  VerificationFailedIcon: VerificationFailed,
  ScanOutline: ScannerOutline,
  GlobeIcon: GlobeSvgIcon,
  ArrowDown: ArrowDownSvgIcon,
  ArrowUp: ArrowUpSvgIcon,
  Check: CheckSvgIcon,
  UnderConstruction: UnderConstructionLogo,
  DownloadIcon: Download,
  WhiteDownloadIcon: WhiteDownload,
  SearchIcon: Search,
  QrCodeOutLine: QrOutline,
  FilterLinesIcon: FilterLines,
  ReGenerateIcon: ReGenerate,
  WhiteReGenerateIcon: WhiteReGenerate,
  CloseIcon: CrossIcon,
  MenuIcon: HamburgerIcon,
  NewTabIcon: TabIcon,
  VectorDown: VectorDownArrow,
  VectorUp: VectorUpArrow,
  VectorOutline: VectorOutline,
  VectorExpand: VectorExpandIcon,
  VectorCollapse: VectorCollapseIcon,
  VectorDownload: VectorDownloadIcon,
  SharableLink: SharableLinkIcon,
};

export default carTheme;
